import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Icon, Image, ShowIf } from '@ztechapps/webui.util'
import { formatDateTime } from '@ztechapps/common.utils'

export const BlogHeader = ({ cover, title, updatedAt }) => {
  const hasCover = !isEmpty(cover)

  return (
    <React.Fragment>
      <ShowIf condition={hasCover}>
        <div className="d-flex justify-content-center">
          {/* COUPLING: name="Cover image" must match img[alt='Cover image'] in libs/blog/webui/src/BlogPreview/BlogPreview.module.scss. */}
          <Image url={cover} name="Cover image" className="img-fluid w-100" style={{ maxHeight: 450 }} />
        </div>
      </ShowIf>

      <section className="bg-primary py-2">
        <div className="container">
          <h2 className="text-break">{title}</h2>
          <div className="small">
            <Icon name="clock" /> Updated last {formatDateTime(updatedAt)}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}
